import { initShell } from '../shell/index.js';
import { fetchConfiguration } from '@ovh-ux/manager-config';
import ShellClient from './shell-client.js';
import DirectClientMessageBus from '../message-bus/direct-client.js';
export default class StandaloneShellClient extends ShellClient {
    init() {
        return fetchConfiguration('shell').then((environment) => {
            this.shell = initShell(environment);
            const clientMessageBus = new DirectClientMessageBus();
            const shellMessageBus = new DirectClientMessageBus();
            clientMessageBus.addPeer(shellMessageBus);
            shellMessageBus.addPeer(clientMessageBus);
            this.setMessageBus(clientMessageBus);
            this.shell.setMessageBus(shellMessageBus);
        });
    }
}
//# sourceMappingURL=standalone-shell-client.js.map